<template>
  <div v-if="showComponent">
    <vs-card class="mt-4 mb-4">
      <div slot="header">
        <h3>Reparo do Veículo</h3>
      </div>
      <div>
        <div class="vx-row">
          <!-- Vistoriador -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-select--label">Vistoriador</label>
            <v-select
              class="selectStyle"
              :options="listVistoriadores"
              name="Vistoriador"
              id="Vistoriador"
              v-model="formReparoVeiculo.idVistoriador"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>

          <!-- Veículo na oficina -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-input--label">Veículo já está na oficina?</label>
            <vs-switch
              v-model="formReparoVeiculo.veiculoEmOficina"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Data de Entrada -->
          <div class="vx-col lg:w-1/3 xl:w-1/6 w-full mb-2">
            <label class="vs-input--label">Data de Entrada</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formReparoVeiculo.dataEntrada"
                placeholder="DD/MM/AAAA"
                name="Data de Entrada"
                :disabled="!formReparoVeiculo.veiculoEmOficina"
              />
            </div>
          </div>

          <!-- Previsão de saída -->
          <div class="vx-col lg:w-1/3 xl:w-1/6 w-full mb-2">
            <label class="vs-input--label">Previsão de Saída</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formReparoVeiculo.dataPrevisaoSaida"
                placeholder="DD/MM/AAAA"
                name="Previsão de Saída"
                :disabled="!formReparoVeiculo.veiculoEmOficina"
              />
            </div>
          </div>

          <!-- Data de saída oficial -->
          <div class="vx-col lg:w-1/3 xl:w-1/6 w-full mb-2">
            <label class="vs-input--label">Data de Saída Oficial</label>
            <div class="inputData">
              <flat-pickr
                :config="configDateTimePickerDay"
                v-model="formReparoVeiculo.dataSaidaOficial"
                placeholder="DD/MM/AAAA"
                name="Data de Saída Oficial"
                :disabled="!formReparoVeiculo.veiculoEmOficina"
              />
            </div>
          </div>
        </div>

        <div class="vx-row">
          <!-- Oficina -->
          <div class="vx-col lg:w-1/2 w-full mb-2">
            <label class="vs-select--label">Oficina</label>
            <v-select
              class="selectStyle"
              :options="listOficinas"
              label="labelCompleta"
              name="Oficina"
              v-model="formReparoVeiculo.idFornecedor"
              @option:selected="updateOficina($event)"
              :reduce="(item) => item.idFornecedor"
            ></v-select>
          </div>

          <!-- Cota de Participação Terceiro (%)  -->
          <div class="vx-col lg:w-1/4 w-full mb-2" v-if="terceiro">
            <label class="vs-input--label">Cota de Part. Terceiro (%)</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formReparoVeiculo.cotaParticipacaoTerceiroPorcento"
              name="Cota de Participação Terceiro (%)"
              v-bind="percentConfig"
            />
          </div>

          <!-- Valor da Cota de Participação -->
          <div class="vx-col lg:w-1/4 w-full mb-2" v-if="terceiro">
            <label class="vs-input--label">Valor Cota de Participação</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formReparoVeiculo.valorCotaParticipacaoTerceiro"
              name="Valor da Cota de Participação"
              v-bind="moneyConfig"
            />
          </div>
        </div>

        <!-- Detalhes da oficina -->
        <div class="m-5" v-if="oficinaSelecionada">
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Nome Fantasia</p>
              {{ oficinaSelecionada.nomeFantasia }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Razão Social</p>
              {{ oficinaSelecionada.razaoSocial }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Celular</p>
              {{ oficinaSelecionada.celular }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Telefone</p>
              {{ oficinaSelecionada.telefone }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CPF/CNPJ</p>
              {{ oficinaSelecionada.cpf_cnpj }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Rua</p>
              {{ oficinaSelecionada.endereco }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Número</p>
              {{ oficinaSelecionada.numero }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Bairro</p>
              {{ oficinaSelecionada.bairro }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CEP</p>
              {{ oficinaSelecionada.cep }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Estado</p>
              {{ oficinaSelecionada.estado }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Representante/Contato</p>
              {{ oficinaSelecionada.representanteLegal }}
            </div>
          </div>
        </div>

        <HistoricoOficinas :historicoOficinas="formReparoVeiculo.historicos" />
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Money } from 'v-money';

import HistoricoOficinas from './HistoricoOficinas.vue';

export default {
  props: ['formData', 'dominios', 'terceiro'],
  watch: {
    formData(value) {
      if (!value.reparoVeiculo) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO DETALHES');
        return;
      }

      this.formReparoVeiculo = Object.assign(
        this.formReparoVeiculo,
        value.reparoVeiculo,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.reparoVeiculo = this.formReparoVeiculo;
    },
    'formReparoVeiculo.veiculoEmOficina': function (newValue) {
      if (newValue == false) {
        this.formReparoVeiculo.dataEntrada = null;
        this.formReparoVeiculo.dataPrevisaoSaida = null;
        this.formReparoVeiculo.dataSaidaOficial = null;
        this.formReparoVeiculo.idVistoriador = null;
        this.formReparoVeiculo.idFornecedor = null;
        this.oficinaSelecionada = null;
      }
    },
  },
  components: {
    vSelect,
    flatPickr,
    Money,
    HistoricoOficinas,
  },
  data() {
    return {
      showComponent: true,
      formReparoVeiculo: {
        idVistoriador: null,
        veiculoEmOficina: null,
        dataEntrada: null,
        dataPrevisaoSaida: null,
        dataSaidaOficial: null,
        idFornecedor: null,
        cotaParticipacaoTerceiroPorcento: 0,
        valorCotaParticipacaoTerceiro: 0,
        historicos: [],
      },
      listOficinas: [],
      listVistoriadores: [],
      oficinaSelecionada: null,
      showCotaParticipacao: false,
      showDetalhesOficina: false,

      //Configurações de componentes
      configDateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
      percentConfig: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '%',
        precision: 0,
      },
    };
  },
  methods: {
    updateOficina(value) {
      if (!value) {
        this.formReparoVeiculo.idFornecedor = null;
        this.oficinaSelecionada = null;
        return;
      }

      this.formReparoVeiculo.idFornecedor = value.idFornecedor;
      this.oficinaSelecionada = value;
    },
  },
  mounted() {
    if (!this.formData.reparoVeiculo) {
      console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO DETALHES');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.reparoVeiculo = this.formReparoVeiculo;

    if (this.dominios) {
      this.listOficinas = this.dominios.listOficinas;
      this.listVistoriadores = this.dominios.listVistoriadores;
    }
  },
};
</script>

<style scoped>
.moneyStyle {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}
.inputData > input {
  width: 100%;
}

.selectStyle {
  font-size: 1rem !important;
}
</style>
